import Slider from './slider.vue'

export default Slider



// WEBPACK FOOTER //
// ./src/components/slider/index.js